﻿var core = require('../../js/core.js');

; (function ($, window, document, undefined) {
    var selectPageSize = 10,
        selectPageNumber_ = 1,
        pagecount = 1,
        paginationID = '',
        // значение по умолчанию 
        pluginName = 'PagerPlugins',
        defaults = {
            totalRows: 0,
            sendMethodCaption: '',
            sendMethodObj: null,
        },
        options,
        methods,

        PagerPlugins = function (el, options, methods) {
            this.el = el;
            this.$el = $(el);
            this.opts = $.extend(true, {}, defaults, options, this.$el.data());
            this.methods = methods;

            if (this.el.hasChildNodes()) {
                this.rebuild();
            }
            else
                this.init();
        }

    PagerPlugins.prototype = {

        rebuild: function () {
            this.$dropDownMenu = this.$el.find('.dropdown-menu');
            this.$pager_group = this.$el.children().find('#pager--group');
            this.$selectPageSizebtn = this.$el.find('input.page-count-rows__btn-info');

            this.$dropDownMenu.on('click', this._selectPageSizeDD.bind(this));
            this.$pager_group.on('click', this._ckickPagination.bind(this));
            this.$selectPageSizebtn.on('change', this._changeBtnInfo.bind(this));

            this._update();
        },

        init: function () {
            paginationID = Math.random().toString(36).substr(2, 5) + '--';
            this._builBaseHtml();
            this._buildPageSize();
            this._buildPagination();

            this.$dropDownMenu.on('click', this._selectPageSizeDD.bind(this));
            this.$pager_group.on('click', this._ckickPagination.bind(this))
            this.$selectPageSizebtn.on('change', this._changeBtnInfo.bind(this))
        },

        _changeBtnInfo: function () {
            var inputParam = this.$selectPageSizebtn.val(),
                opt = this.opts,
                maxParam = opt.totalRows;

            if (inputParam > 0 && inputParam <= maxParam) {
                selectPageSize = inputParam;
                selectPageNumber_ = 1;
                this._buildPagination();
                this._sendData();
            }
            else
                alert('Введен недопустимый размер количества строк');


        },

        _ckickPagination: function () {
            var selectItem = event.target;

            if ($(selectItem).hasClass('glyphicon'))
                selectItem = event.target.parentNode;

            var id = selectItem.id.split('--')[1],
                curCountSegment = Math.ceil(selectPageNumber_ / 10);

            this.$pager_group.children().removeClass('active');

            paginationID = selectItem.id.split('--')[0] + '--';

            switch (id) {
                case 'first': // первая страница из всего
                    selectPageNumber_ = 1;
                    break;
                case 'prev': // предыдущая страница
                    if (selectPageNumber_ != 1)
                        selectPageNumber_ = parseInt(selectPageNumber_) - 1
                    else
                        selectPageNumber_ = selectPageNumber_;
                    break;
                case 'many_prev': //предыдущий интервал
                    selectPageNumber_ = 10 * curCountSegment - 10;
                    break;
                case 'many_next': // следующий интервал
                    selectPageNumber_ = 10 * curCountSegment + 1;
                    break;
                case 'next': // следующая страница
                    if (selectPageNumber_ != pagecount)
                        selectPageNumber_ = parseInt(selectPageNumber_) + 1;
                    else
                        selectPageNumber_ = selectPageNumber_;
                    break;
                case 'last': // последняя страница из всего
                    selectPageNumber_ = pagecount;
                    break;
                default: // 1-10
                    selectPageNumber_ = id;
                    break;
            }
            selectPageSize = this.$selectPageSizebtn.val();
            this._buildPagination();
            this._sendData();
        },

        // событие для выбора кол-ва строк на странице
        _selectPageSizeDD: function () {
            var selectItem = event.target,
                id = selectItem.id.split('--')[1];

            paginationID = selectItem.id.split('--')[0] + '--';

            selectPageSize = id;
            this.$selectPageSizebtn.val(selectPageSize);
            this._update();
        },

        // отправка 
        _sendData: function () {
            var opt = this.opts,
                sendMethodCaption = opt.sendMethodCaption,
                sendObjTo = opt.sendMethodObj,
                searchObj = opt.searchObj,
                ObjM = this.methods;

            if (sendObjTo) {
                sendObjTo.PageSize = selectPageSize,
                    sendObjTo.PageNumber = selectPageNumber_
            }
            else {
                sendObjTo = {
                    PageSize: selectPageSize,
                    PageNumber: selectPageNumber_
                };
            }

            if (searchObj != undefined && Object.keys(searchObj).length != 0) {
                $.each(searchObj, (key, val) => {
                    sendObjTo[key] = val;
                })

            }
            // alert('Метод:' + sendMethodCaption + ' selectPageSize:' + selectPageSize + ' selectPageNumber_:' + selectPageNumber_);

            if (sendMethodCaption != '') {
                this._sendAjaxData(sendMethodCaption, sendObjTo)
            }

        },

        _update: function () {
            selectPageSize = this.$selectPageSizebtn.val();
            selectPageNumber_ = 1;
            this._buildPagination();
            this._sendData();
        },


        _sendAjaxData(captionSendMethod, sendObj) {
            var ObjM = this.methods;
            let sendJSON = JSON.stringify(sendObj);
            core.startLoadingAnimation();
            $.ajax({
                type: "POST",
                url: captionSendMethod,
                cache: false,
                data: "{inputsParam:'" + sendJSON + "'}",
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    ObjM.show(JSON.parse(data.d));
                    core.stoptLoadingAnimation();
                },
                error: function (data) {

                }
            })
        },

        // создание базовой разметки
        _builBaseHtml: function () {

            var _this = this,
                el = _this.el,
                $el = $(el),
                $elTarget = $el;

            var $baseContainer = $('<div/>', {
                id: 'base--Container',
                class: 'form-group row sumline'
            });


            var $containerPageGr = $('<div/>', {
                id: 'container_pager_size',
                class: 'col-5 col-lg-8'
            });

            var $ContainerpageSize = $('<div/>', {
                class: "col-7 col-lg-4",
            })

            var $pager_group = $('<div/>', {
                id: 'pager--group',
                class: 'pager_group',
                class: 'btn-group'
            }).appendTo($containerPageGr);

            this.$pager_group = $pager_group;
            this.$pageSizeContainer = $ContainerpageSize;

            $baseContainer.append($containerPageGr).append($ContainerpageSize).appendTo($el);
            this.$el = $el;
        },

        // создание панельки выбора строк на странице
        _buildPageSize: function () {
            var $pageSizeContainer = this.$pageSizeContainer;

            var $pagecountrows = $('<div/>', { class: "page-count-rows", text: 'Строк на странице:' }),
                $btngr = $('<div class="btn-group">'),
                $dropDownMenu = $('<div class="dropdown-menu">'),
                $selectPageSizebtn = $('<input/>', { type: 'text', id: paginationID + 'page-Size-btn', class: "form-control page-count-rows__btn-info", value: '10', css: { 'width': '4rem' } });

            $btngr.append($selectPageSizebtn);
            $btngr.append('<button type="button" class="btn btn-default dropdown-toggle dropdown-toggle-split page-count-rows__btn-select" data-toggle="dropdown" aria-haspopup="true"> </button>');

            $dropDownMenu.append('<a id="' + paginationID + '5" class="dropdown-item">5</a>');
            $dropDownMenu.append('<a id="' + paginationID + '10" class="dropdown-item">10</a>');
            $dropDownMenu.append('<a id="' + paginationID + '25" class="dropdown-item">25</a>');
            $dropDownMenu.append('<a id="' + paginationID + '50" class="dropdown-item">50</a>');

            $dropDownMenu.appendTo($btngr);
            $btngr.appendTo($pagecountrows);
            $pageSizeContainer.append($pagecountrows);

            this.$dropDownMenu = $dropDownMenu;
            this.$selectPageSizebtn = $selectPageSizebtn;

            this.$pageSizeContainer = $pageSizeContainer;
        },


        //создание кнопок постраничного перехода 
        _buildPagination: function () {
            var option = this.opts,
                total = option.totalRows,
                countSegment = 1,
                segment = 10,
                _pagecount = 1;

            if (Math.round(parseInt(total) / parseInt(selectPageSize)) != 0)
                _pagecount = Math.ceil(parseInt(total) / parseInt(selectPageSize));


            var curCountSegment = Math.ceil(selectPageNumber_ / segment),
                maxCountSegment = Math.ceil(_pagecount / segment),
                fsegment = curCountSegment * segment + 1 - segment,
                lsegment = (curCountSegment * segment) > _pagecount ? _pagecount : (curCountSegment * segment),
                htmltxt = '';


            htmltxt += '<li class="page-item page-base"><a class="page-link" id="' + paginationID + 'first"><span class="glyphicon glyphicon-step-backward"></span></a></li>';
            htmltxt += '<li class="page-item page-base"><a class="page-link" id="' + paginationID + 'prev" ><span class="glyphicon glyphicon-chevron-left"></span></a></li>';
            
            if (curCountSegment == countSegment && curCountSegment == maxCountSegment)
                // нет ... 
                for (var i = fsegment; i <= lsegment; ++i)
                    htmltxt += '<li class="page-item"><a class="page-link" id="' + paginationID + i + '" >' + i + '</a></li>';
            else if (curCountSegment == countSegment && curCountSegment < maxCountSegment) {
                for (var i = fsegment; i <= lsegment; ++i)
                    htmltxt += '<li class="page-item"><a class="page-link" id="' + paginationID + i + '">' + i + '</a></li>';
                htmltxt += '<li class="page-item"><a class="page-link" id = "' + paginationID + 'many_next" >...</a></li>';
            }
            else
                if (curCountSegment > countSegment && curCountSegment < maxCountSegment) {
                    //...
                    htmltxt += '<li class="page-item"><a class="page-link" id = "' + paginationID + 'many_prev" >...</a></li>';
                    for (var i = fsegment; i <= lsegment; ++i)
                        htmltxt += '<li class="page-item"><a class="page-link" id="' + paginationID + i + '" >' + i + '</a></li>';
                    htmltxt += '<li class="page-item"><a class="page-link" id = "' + paginationID + '-many_next">...</a></li>';
                }
                else
                    if (curCountSegment > countSegment && curCountSegment == maxCountSegment) {
                        //...
                        htmltxt += '<li class="page-item"><a class="page-link" id = "' + paginationID + 'many_prev">...</a></li>';
                        for (var i = fsegment; i <= lsegment; ++i)
                            htmltxt += '<li class="page-item"><a class="page-link" id="' + paginationID + i + '" >' + i + '</a></li>';
                    }

            htmltxt += '<li class="page-item page-base"><a class="page-link"  id="' + paginationID + 'next"><span class="glyphicon glyphicon-chevron-right"></span></a></li>';
            htmltxt += '<li class="page-item page-base"><a class="page-link"  id="' + paginationID + 'last"><span class="glyphicon glyphicon-step-forward"></span></a></li>';
            this.$pager_group.html(htmltxt);
            $('#' + paginationID + selectPageNumber_).parent().addClass('active');
            pagecount = _pagecount;
        }
    }



    $.fn.PagerPlugins = function (options, methods) {

        // при многократном вызове функции настройки будут сохранятся, и замещаться при необходимости
        // options = $.extend({}, defaults, options, params);
        return this.each(function () {
            if (!$.data(this, pluginName)) {

                $.data(this, pluginName,
                    new PagerPlugins(this, options, methods));
            } else {
                $(this).empty();
                $.data(this, pluginName,
                    new PagerPlugins(this, options, methods));
            }
        });
    };

    $.fn.PagerPlugins.Constructor = PagerPlugins;



})(jQuery, window, document);


//////////////////
// WEBPACK FOOTER
// ./Plugins/pager/Pager.js
// module id = 3
// module chunks = 0